var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03579 1.81663C5.40263 1.07346 6.46237 1.07346 6.82921 1.81663L7.5332 3.24284C7.67874 3.53768 7.95992 3.74214 8.28528 3.7897L9.86122 4.02004C10.6811 4.13989 11.0079 5.14773 10.4143 5.72589L9.27554 6.83506C9.03966 7.0648 8.932 7.39593 8.98766 7.72046L9.25621 9.28625C9.39633 10.1032 8.53878 10.7262 7.80515 10.3404L6.39795 9.60033C6.10657 9.44709 5.75843 9.44709 5.46705 9.60033L4.05985 10.3404C3.32622 10.7262 2.46867 10.1032 2.60879 9.28624L2.87734 7.72046C2.933 7.39593 2.82533 7.0648 2.58946 6.83506L1.45068 5.72589C0.857084 5.14773 1.18387 4.13989 2.00378 4.02004L3.57972 3.7897C3.90508 3.74214 4.18626 3.53768 4.3318 3.24284L5.03579 1.81663Z",
    fill: "#99A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.13a7a38d26e2a20b81616379f0ea1afe.svg";
export { ForwardRef as ReactComponent };